import { ReactElement } from 'react';

export default function ThaliakContainer({ children }: { children: ReactElement }) {
  return children;
}
